// sites.js — os três sites da Insigne, para um levar ao outro (18/10/2026).
//
// O dono notou que a loja não tinha caminho para o site principal nem para o
// do Congresso. A mesma lista existe nos outros dois projetos (landing:
// src/components/navbar/navegacao.ts; CIDA: src/dados/sites.js), porque são
// builds separados; mudar um endereço aqui é mudar lá também.
//
// Os endereços são absolutos: cada site é outro app React, e um <Link> do
// router desta loja não sairia de /editora-insigne/.
export const SITES = [
  {
    chave: "insigne",
    rotulo: "Insigne Acadêmica",
    curto: "INSIGNE ACADÊMICA",
    resumo: "A editora, o mentor e o plano",
    icone: "bi-mortarboard",
    url: "https://insigneacademica.com.br/",
  },
  {
    chave: "editora",
    rotulo: "Editora e livraria",
    curto: "EDITORA",
    resumo: "Livros, autores e o Clube",
    icone: "bi-shop",
    url: "https://insigneacademica.com.br/editora-insigne/",
  },
  {
    chave: "cida",
    rotulo: "Congresso (CIDA)",
    curto: "CONGRESSO CIDA",
    resumo: "Edital, submissão e inscrição",
    icone: "bi-easel",
    url: "https://insigneacademica.com.br/cida/",
  },
];

/** Este site. */
export const SITE_ATUAL = "editora";

/** Os outros dois. */
export const OUTROS_SITES = SITES.filter((s) => s.chave !== SITE_ATUAL);
